/* istanbul ignore file */
import { SET_GOAL_TRANSACTIONS } from './actionTypes'

export const setGoalTransactions = items => {
  return {
    type: SET_GOAL_TRANSACTIONS,
    items
  }
}
